





















import { EnumType } from 'expangine-runtime';
import { EnumRadioOptions } from './EnumRadioTypes';
import { TypeSettings } from '../TypeVisuals';
import { EnumSubs } from './EnumTypes';
import { ListOptions } from '../../../common';
import TypeInputBase from '../TypeInputBase';


export default TypeInputBase<EnumType, EnumRadioOptions, any, EnumSubs>().extend({
  name: 'EnumRadio',
  computed: {
    entries(): Array<[any, any]> {
      return Array.from(this.type.options.constants.entries());
    },
    hasHint(): boolean {
      return !this.hideHint;
    },
    hideHint(): boolean {
      return !this.settings.options.hint;
    },
  },
});
